module.exports = __webpack_public_path__ + "static/media/VysokieTechnologii-dark.176d386b.webp";